export enum EnumPartnerProtfolioCNPJ {
  "0-30" = "0-30",
  "31-99" = "31-99",
  "100+" = "100+",
}
